module.exports = __webpack_public_path__ + "static/media/document-dummy.2942bfab.pdf";